module.exports = __webpack_public_path__ + "img/1341207-62-2.b6a08a05.png";